export const MemberTypes = {
  EXISTING_MEMBERS: 'EXISTING_MEMBERS',
  CSV_FILE:         'CSV_FILE'
};

export const MemberStatuses = {
  LOADING:    'LOADING',
  LOADED:     'LOADED',
  LOAD_ERROR: 'LOAD_ERROR'
};

export const ResultStatuses = {
  PENDING:  'Pending',
  LOADING:  'Loading...',
  COMPLETE: 'Complete',
  CANCELED: 'Canceled',
  ERROR:    'Error'
};

export const SKUS = [
  { skuCode: 'GMMDCONSULT', defaultCost: '45', sku_name: 'General Medical Consult' },
  { skuCode: 'BHMDINITIAL', defaultCost: '160', sku_name: 'Mental Health MD Initial Consult' },
  { skuCode: 'BHMDFOLLOWUP', defaultCost: '90', sku_name: 'Mental Health MD Followup Consult' },
  { skuCode: 'BHNONMD', defaultCost: '80', sku_name: 'Mental Health NonMD Consult' },
  { skuCode: 'BHNONMDPSYCHOLOGY', defaultCost: '100', sku_name: 'Mental Health NonMD Psychology Consult' },
  { skuCode: 'DERMMD', defaultCost: '75', sku_name: 'Dermatology MD Consult' },
  { skuCode: 'NUTRITION', defaultCost: '45', sku_name: 'Nutrition Consult' },
  { skuCode: 'VPCMDCONSULTINITIAL', defaultCost: '150', sku_name: 'Primary Care New Patient Visit' },
  { skuCode: 'VPCMDCONSULT', defaultCost: '50', sku_name: 'Primary Care Follow-up Visit' },
  { skuCode: 'CHRONICKIDNEYDISEASECARE', defaultCost: '', sku_name: 'Chronic Kidney Disease Chronic Care Rate' },
  { skuCode: 'DIABETESCCARE', defaultCost: '', sku_name: 'Diabetes Chronic Care Rate' },
  { skuCode: 'DIABETESCARECRATE', defaultCost: '', sku_name: 'Diabetes Care Case Rate' },
  { skuCode: 'DIABETESCKDVARIANTCRATE', defaultCost: '', sku_name: 'Diabetes Management with CKD Aware Variant Case Rate' },
  { skuCode: 'DIABETESFLEXCRATE', defaultCost: '', sku_name: 'Diabetes Flex Case Rate' },
  { skuCode: 'HEARTFAILURECRATE', defaultCost: '', sku_name: 'Heart Failure Case Rate' },
  { skuCode: 'HYPERTENSIONCCARE', defaultCost: '', sku_name: 'Hypertension Chronic Care Rate' },
  { skuCode: 'HYPERTENSIONCKDVARIANTCRATE', defaultCost: '', sku_name: 'Hypertension Management with CKD Aware Variant Case Rate' },
  { skuCode: 'MYMENTALHEALTHCCARE', defaultCost: '', sku_name: 'myStrength Chronic Care Rate' },
  { skuCode: 'MYMENTALHEALTH1CCARE', defaultCost: '', sku_name: 'myStrength Global Chronic Care Rate' },
  { skuCode: 'MYMENTALHEALTH2CCARE', defaultCost: '', sku_name: 'Livongo for Behavioral Health by myStrength (myStrength 2.0) Chronic Care Rate' },
  { skuCode: 'MYMENHEALTHCOMPCCARE', defaultCost: '', sku_name: 'myStrength Complete Chronic Care Rate' },
  { skuCode: 'MYSTRENGTHPLUSCRATE', defaultCost: '', sku_name: 'myStrength Plus Case Rate' },
  { skuCode: 'PREDIABETESCCARE', defaultCost: '', sku_name: 'Prediabetes Chronic Care Rate' },
  { skuCode: 'WEIGHTMANAGEMENTCARE', defaultCost: '', sku_name: 'Weight Management Chronic Care Rate' }
];
